import React, { useEffect } from 'react'
import {
  UserOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import { Avatar, Dropdown } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/store';
import { ValidateTokenAuthReducer } from '../../redux/actions/auth/login/Login';
interface MenuProfileProps {
  image?: string;
}

const API_URL = process.env.REACT_APP_API_BASE_URL;

const MenuProfile: React.FC<MenuProfileProps> = ({
  image = 'https://img.freepik.com/vector-gratis/avatar-personaje-empresario-aislado_24877-60111.jpg',
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  
  const { rex_user, rex_validate_user } = useSelector((state: RootState) => state.login);
  
  useEffect(() => {
    const token = localStorage.getItem('token');
    
    if (token && !rex_user) {
      dispatch(ValidateTokenAuthReducer() as any);
    }
  }, [dispatch, rex_user]);
  
  const nombreCompleto = rex_user && rex_user.personas 
    ? `${rex_user.personas.nombre || ''} ${rex_user.personas.apellidos || ''}`.trim() 
    : "Usuario";
  
  const nombreEmpresa = rex_user && rex_user.empresa 
    ? rex_user.empresa.nombre 
    : "";
  
  const nombreMostrado = nombreEmpresa 
    ? `${nombreCompleto} - ${nombreEmpresa}` 
    : nombreCompleto;

  const getPlanProfile = (plans: any) => {
    if (!plans || plans.length === 0) {
      return 'Free';
    }
    return plans[0]?.['planes']?.['plan'] ?? 'Free';
  }

  const items: any = [
    {
      label: (
        <div className='flex py-4 px-4 item-menu-profile cursor-default'>
          <div>
            {rex_user && rex_user.imagen_perfil ? (
              <img
                src={`${API_URL}${rex_user.imagen_perfil}`}
                className='rounded-md h-[100%] w-[60px]'
                alt="Perfil"
              />
            ) : (
              <Avatar icon={<UserOutlined />} size={60} />
            )}
          </div>
          <div className='pl-2'>
            <div className='flex items-center'>
              <div className='text-base font-semibold dark:text-white overflow-hidden'>{nombreCompleto}</div>
              <span className='text-xs font-bold bg-[#DDF5F0] ml-2 rounded text-[#00AB55] px-1 h-max'>{getPlanProfile("Free")}</span>
            </div>
            <div className='text-sm font-semibold text-[#0e172699] hover:text-[#607BF0] dark:text-white cursor-pointer'>
              {rex_user?.email || "email@ejemplo.com"}
            </div>
            {nombreEmpresa && (
              <div className='text-sm text-[#0e172699] dark:text-gray-300'>{nombreEmpresa}</div>
            )}
          </div>
        </div>
      ),
      key: '0',
    },
    {
      label: <div
        onClick={() => navigate('/my-profile')}
        className='flex px-4 py-2 gap-1 group hover:bg-[#ECEFFD]'
      >
        <UserOutlined className='text-base group-hover:text-[#4361ee]' />
        <div className='ml-1 text-sm font-semibold dark:group-hover:text-white group-hover:text-[#4361ee]'>Mi Perfil</div>
      </div>,
      key: '1',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <div
          className='flex px-4 py-3 gap-1 group hover:bg-[#ECEFFD]'
          onClick={() => {
            localStorage.clear();
            window.location.href = "/login";
          }}
        >
          <LogoutOutlined className='text-[18px] text-[#E7515A] group-hover:text-[#4361ee]' />
          <div className='pt-1 ml-1 text-sm font-semibold text-[#E7515A] dark:group-hover:text-white group-hover:text-[#4361ee]'>Cerrar Sesión</div>
        </div>
      ),
      key: '3',
    },
  ];

  return (
    <div className='flex items-center h-9 gap-2'>
      <Dropdown
        menu={{
          items,
        }}
        trigger={['click']}
        overlayClassName='menu-profile'
      >
        <div className='flex items-center gap-1 h-9 cursor-pointer'>
          <Avatar 
            style={{ color: '#000000', backgroundColor: '#E3E9EF' }} 
            size={36} 
            icon={rex_user && rex_user.imagen_perfil ? 
              <img src={`${API_URL}${rex_user.imagen_perfil}`} alt="Avatar"/> : 
              <UserOutlined />
            } 
            
          />
          <div className='font-semibold select-none'>{nombreMostrado}</div>
        </div>
      </Dropdown>
    </div>
  )
}

export default MenuProfile